export default "__VITE_PUBLIC_ASSET__519706a3__"